import AppButton, { AppButtonProps } from "./AppButton";

/** Save, OK, Submit, Confirm... */
const ActionButton = (props: Omit<AppButtonProps, "appVariant">) => (
  <AppButton appVariant="action" {...props} />
);

export default ActionButton;
